import FinishResultCard from "./FinishResultCard";

export default FinishResultCard